module.exports = __webpack_public_path__ + "static/img/gongan.d0289dc0.png";